import React, { useState } from "react"

import axios from "../../http/axios"

import ArrowLeftIconDark from "../../svg/arrow-left-dark.inline.svg"
import { useTranslation } from "react-i18next"

const SideNavForgotPasswordSection = props => {
  const { t } = useTranslation()

  const [passwordNotValid, setPasswordNotValid] = useState(false)
  const [formValues, setFormValues2] = useState({ email: "" })

  let passwordIsNotValid = passwordNotValid ? "password-not-valid" : ""

  function handleSubmit(e) {
    e.preventDefault()
    axios
      .post("/password-recovery/request", { email: formValues.email })
      .then(res => {
        props.checkEmailFunction()
        props.passUserEmail(res)
      })
      .catch(error => {
        setPasswordNotValid(true)
      })
  }

  const handleInputChanges = e => {
    e.persist()
    setFormValues2(currValues => ({
      ...currValues,
      [e.target.name]: e.target.value,
    }))
    setPasswordNotValid(false)
  }

  return (
    <div className="side-nav-user-wrapper" id="school-wrapper">
      <div className="ps-5 side-nav-user-top">
        <div className="f-ac f-js f-1">
          <div
            id="backSchool"
            className="closebtn icon_button"
            onClick={props.backFunction}
          >
            <ArrowLeftIconDark className="arrow_left_dark" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="side-nav-user-info px-10">
          <form onSubmit={handleSubmit}>
            <div className="login-with-wrapper">
              <div className="title-forgot-password">
                {t("main.header.forgotPassword")}
              </div>
              <div id="login" className="recommend-text">
                {t("main.header.forgotPassword")} {t("main.header.enterEmail")}
              </div>
            </div>
            <div className="forgot-pass">
              <div className="input-group w-100">
                <input
                  className={`form-field w-100 ${passwordIsNotValid}`}
                  type="email"
                  name="email"
                  required
                  value={formValues.email}
                  onChange={handleInputChanges}
                  placeholder={t("main.header.email")}
                />

                {passwordNotValid && (
                  <span className="error">
                    {t("main.header.ivalidEmailAccount")}
                  </span>
                )}
              </div>
              <button className="form-field login-button w-100" type="submit">
                {t("main.header.sendResetLink")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default SideNavForgotPasswordSection
